<blui-mobile-stepper
  [steps]="steps()"
  [activeStep]="activeStep()"
  [variant]="variant() ?? defaultVariant"
></blui-mobile-stepper>
